import { Dropdown } from "primereact/dropdown";
import React from "react";
import { useSelector } from "react-redux";

const IssueFields = ({
  form,
  handleChange,
  error,
  data,
  departmentData = [],
  locationData = [],
}) => {
  const issueByData =
    useSelector((state) => state.getGenMaster?.user?.data) || [];
  const projectData =
    useSelector((state) => state.getProject?.user?.data) || [];
  const partyData = useSelector((state) => state.getParty?.user?.data) || [];
  const transportData =
    useSelector((state) => state.getTransport?.user?.data) || [];
  const paidByData = [
    {
      label: "Owner",
      value: "owner",
    },
    {
      label: "Party",
      value: "party",
    },
  ];

  const statusData = [
    { label: "Pending", value: 1 },
    { label: "Rejected", value: 4 },
  ];

  const selectedProject = projectData.find(
    (p) => p._id === form.project_id
  );

  const receivedByOptions = issueByData.filter((rev) => rev.tag_number === 19)
  const authoRisedByOptions = issueByData.filter((rev) => rev.tag_number === 18)
  const takenByOptions = issueByData.filter((rev) => rev.tag_number === 20)

  return (
    <>
      <div className="row">
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>
              Project <span className="login-danger">*</span>
            </label>
            <Dropdown
              value={form.project_id}
              options={projectData?.map((e) => ({
                label: e.project_no ? `${e.name} (${e.project_no})` : e.name,
                value: e._id,
              }))}
              onChange={(e) =>
                handleChange({ target: { name: "project_id", value: e.value } })
              }
              placeholder="Select Project"
              filter
              className="w-100"
              disabled={data?._id}
            />
            <div className="error">{error?.project_id}</div>
          </div>
        </div>
          <div className="col-12 col-md-4 col-xl-4">
            <div className="input-block local-forms">
              <label>Project No</label>
              <input
                type="text"
                name="manual_pro_no"
                value={form?.manual_pro_no || ""}
                onChange={handleChange}
                placeholder="Enter Project No"
                className="form-control"
              />
            </div>
          </div>
        {/* <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>
              Party <span className="login-danger">*</span>
            </label>
            <Dropdown
              value={form.party_id}
              options={partyData?.map((e) => ({ label: e.name, value: e._id }))}
              onChange={(e) =>
                handleChange({ target: { name: "party_id", value: e.value } })
              }
              placeholder="Select Party"
              filter
              className="w-100"
              disabled={data?._id}
            />
            <div className="error">{error?.party_id}</div>
          </div>
        </div> */}
        {data?._id && (
          <div className="col-12 col-md-4 col-xl-4">
            <div className="input-block local-forms">
              <label>Issue No.</label>
              <input
                type="text"
                className="form-control"
                value={data?.voucher_no}
                readOnly
              />
            </div>
          </div>
        )}
      </div>
      <div className="row">
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>
              Date <span className="login-danger">*</span>
            </label>
            <input
              type="date"
              className="form-control"
              name="trans_date"
              onChange={handleChange}
              value={form.trans_date}
            />
            {error.trans_date && (
              <div className="error">{error.trans_date}</div>
            )}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>
              Issue Date <span className="login-danger">*</span>
            </label>
            <input
              type="date"
              className="form-control"
              name="receive_date"
              onChange={handleChange}
              value={form.receive_date}
            />
            {error.receive_date && (
              <div className="error">{error.receive_date}</div>
            )}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>
              {" "}
              Bill No. <span className="login-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="bill_no"
              onChange={handleChange}
              value={form.bill_no}
            // disabled
            />
            {error.bill_no && <div className="error">{error.bill_no}</div>}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>
              Received By <span className="login-danger">*</span>
            </label>
            <Dropdown
              value={form.master_id}
              options={receivedByOptions?.map((e) => ({
                label: e.name,
                value: e._id,
              }))}
              onChange={(e) =>
                handleChange({ target: { name: "master_id", value: e.value } })
              }
              placeholder="Select Received By"
              filter
              className="w-100"
            />
            {error.master_id && <div className="error">{error.master_id}</div>}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>
              Authorised By <span className="login-danger">*</span>
            </label>
            <Dropdown
              value={form.authorised_id}
              options={authoRisedByOptions?.map((e) => ({
                label: e.name,
                value: e._id,
              }))}
              onChange={(e) =>
                handleChange({ target: { name: "authorised_id", value: e.value } })
              }
              placeholder="Select Authorised By"
              filter
              className="w-100"
            />
            {error.authorised_id && <div className="error">{error.authorised_id}</div>}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>
              Taken By <span className="login-danger">*</span>
            </label>
            <Dropdown
              value={form.taken_id}
              options={takenByOptions?.map((e) => ({
                label: e.name,
                value: e._id,
              }))}
              onChange={(e) =>
                handleChange({ target: { name: "taken_id", value: e.value } })
              }
              placeholder="Select Taken By"
              filter
              className="w-100"
            />
            {error.taken_id && <div className="error">{error.taken_id}</div>}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>Department </label>
            <Dropdown
              value={form.department_id}
              options={departmentData?.map((d) => ({
                label: d.name,
                value: d._id,
              }))}
              onChange={(e) =>
                handleChange({
                  target: { name: "department_id", value: e.value },
                })
              }
              showClear
              filter
              placeholder="Select Department"
              className="w-100"
            />
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>Store Location</label>
            <Dropdown
              value={form.store_location_id}
              options={locationData?.map((l) => ({
                label: l.name,
                value: l._id,
              }))}
              onChange={(e) =>
                handleChange({
                  target: { name: "store_location_id", value: e.value },
                })
              }
              showClear
              filter
              placeholder="Select Store Location"
              className="w-100"
            />
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>
              {" "}
              Transport <span className="login-danger">*</span>
            </label>
            <Dropdown
              value={form.transport_id}
              options={transportData?.map((e) => ({
                label: e.name,
                value: e._id,
              }))}
              onChange={(e) =>
                handleChange({
                  target: { name: "transport_id", value: e.value },
                })
              }
              placeholder="Select Transport"
              filter
              className="w-100"
            />
            {error.transport_id && (
              <div className="error">{error.transport_id}</div>
            )}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>Transport Date </label>
            <input
              type="date"
              className="form-control"
              name="transport_date"
              onChange={handleChange}
              value={form.transport_date}
            />
            {error.transport_date && (
              <div className="error">{error.transport_date}</div>
            )}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>Transport Charges </label>
            <input
              type="number"
              className="form-control"
              name="transport_charges"
              onChange={handleChange}
              value={form.transport_charges}
            />
            {error.transport_charges && (
              <div className="error">{error.transport_charges}</div>
            )}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label> LR No. </label>
            <input
              type="text"
              className="form-control"
              name="lr_no"
              onChange={handleChange}
              value={form.lr_no}
            />
            {error.lr_no && <div className="error">{error.lr_no}</div>}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>LR Date</label>
            <input
              type="date"
              className="form-control"
              name="lr_date"
              onChange={handleChange}
              value={form.lr_date}
            />
            {error.lr_date && <div className="error">{error.lr_date}</div>}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label> Vehicle No.</label>
            <input
              type="text"
              className="form-control"
              name="vehical_no"
              onChange={handleChange}
              value={form.vehical_no}
            />
            {error.vehical_no && (
              <div className="error">{error.vehical_no}</div>
            )}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label> Paid By</label>
            <Dropdown
              value={form.paid_by}
              options={paidByData}
              onChange={(e) =>
                handleChange({ target: { name: "paid_by", value: e.value } })
              }
              placeholder="Select Paid By"
              filter
              className="w-100"
            />
            {error.paid_by && <div className="error">{error.paid_by}</div>}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label> Gate Pass</label>
            <input
              type="text"
              className="form-control"
              name="get_pass"
              onChange={handleChange}
              value={form.get_pass}
            />
            {error.get_pass && <div className="error">{error.get_pass}</div>}
          </div>
        </div>

        {data?._id && data?.status === 4 && (
          <div className="col-12 col-md-4 col-xl-4">
            <div className="input-block local-forms custom-select-wpr">
              <label>Status</label>
              <Dropdown
                value={form.status}
                options={statusData}
                onChange={(e) =>
                  handleChange({ target: { name: "status", value: e.value } })
                }
                placeholder="Select Status"
                className="w-100"
                showClear
              />
            </div>
          </div>
        )}

        <div className="col-12 ">
          <div className="input-block local-forms">
            <label>Reason/Purpose</label>
            <textarea
              type="text"
              className="form-control"
              onChange={handleChange}
              name="remarks"
              value={form.remarks}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="input-block local-forms">
            <label>Address</label>
            <textarea
              type="text"
              className="form-control"
              name="address"
              onChange={handleChange}
              value={form.address}
            />
            {error.address && <div className="error">{error.address}</div>}
          </div>
        </div>
      </div>
    </>
  );
};

export default IssueFields;
